import request from "./request";

const api = {
    // 获取数据
    addContact: function (data) {
        return request({
            url: `pangoo/contact-us/add`,
            method: "post",
            data,
        });
    },
};

export default {
    ...api,
};
